/**
 * Поля размеров предмета каталога: ширина, глубина, высота.
 *
 * Одни и те же у предмета на полу и на стене. Пределы у каждого поля — свои у предмета
 * (`itemSizeRange`): поле не даст ввести больше или меньше, а пользователь не гадает,
 * почему у одного предмета размер меняется, а у другого нет. Как именно предмет
 * растёт — какая сторона стоит на месте, — решает тот, кто передал `onResize`.
 */
import { UIKit } from "@/shared/ui";
import { SIZE_STEP, itemSizeRange, type CatalogItem, type SizeAxis } from "@/shared/catalog";

const FIELDS: { axis: SizeAxis; label: string }[] = [
	{ axis: "width", label: "Ширина" },
	{ axis: "depth", label: "Глубина" },
	{ axis: "height", label: "Высота объекта" },
];

interface Props {
	info: CatalogItem;
	dimensions: Record<SizeAxis, number>;
	/** Раздел каталога не разрешает менять размеры */
	disabled: boolean;
	onResize: (axis: SizeAxis, value: number) => void;
}

export const ItemSizeFields = ({ info, dimensions, disabled, onResize }: Props) => (
	<>
		{FIELDS.map(({ axis, label }) => {
			const range = itemSizeRange(info, axis);
			return (
				<UIKit.NumberField
					key={axis}
					label={label}
					value={dimensions[axis]}
					min={range.min}
					max={range.max}
					step={SIZE_STEP}
					disabled={disabled}
					onChange={(value) => onResize(axis, value)}
				/>
			);
		})}
	</>
);
